import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function memberRecycleReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_MEMBER_RECYCLE:
    case actions.TRIGGER_MEMBER_RECYCLE:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBER_RECYCLE_ENDED:
    case actions.TRIGGER_MEMBER_RECYCLE_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MEMBER_RECYCLES:
    case actions.GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBER_RECYCLES_ENDED:
    case actions.GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_MEMBER_RECYCLE:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_MEMBER_RECYCLE_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_MEMBER_RECYCLES:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_MEMBER_RECYCLES_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
